import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';
import moment from 'moment';

export function toLocalTime(d: string) {
  const utcDate = moment.utc(d);
  const localDate = moment(utcDate).local();
  const now = new Date();

  return localDate.toDate() > now ? now : localDate.toDate();
}

TimeAgo.addDefaultLocale(en);
export const timeAgo = new TimeAgo('en-GB');
